var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronMiniDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.5C9.82984 13.4991 9.662 13.4604 9.50867 13.3866C9.35533 13.3128 9.22035 13.2058 9.1135 13.0733L6.30739 9.67333C6.14341 9.46865 6.04023 9.222 6.00959 8.96151C5.97895 8.70102 6.02209 8.43716 6.13409 8.2C6.22492 7.99388 6.37315 7.81828 6.56108 7.69415C6.74901 7.57002 6.96869 7.50262 7.19388 7.5L12.8061 7.5C13.0313 7.50262 13.251 7.57002 13.4389 7.69415C13.6268 7.81828 13.7751 7.99389 13.8659 8.2C13.9779 8.43716 14.0211 8.70102 13.9904 8.96151C13.9598 9.222 13.8566 9.46865 13.6926 9.67333L10.8865 13.0733C10.7796 13.2058 10.6447 13.3128 10.4913 13.3866C10.338 13.4604 10.1702 13.4991 10 13.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronMiniDown);
export default __webpack_public_path__ + "static/media/Chevron-Mini-Down.a3978b5a0675474cbf3a55fdfd226f82.svg";
export { ForwardRef as ReactComponent };